import { BufferGeometry, Mesh } from 'three';
import { PLYExporter } from 'three/examples/jsm/exporters/PLYExporter.js';
import { PLYExportOptions } from '@/modules/three/common/halfEdgeMesh/HalfEdgeMesh.js';

export function meshToPly(mesh: Mesh, options: PLYExportOptions = {}): Promise<Blob> {
  return new Promise((resolve) => {
    mesh.updateMatrixWorld(true);

    const baked = mesh.geometry.clone();
    baked.applyMatrix4(mesh.matrixWorld);

    const tempMesh = new Mesh(baked);

    const exporter = new PLYExporter();
    exporter.parse(
      tempMesh,
      (data: string | ArrayBuffer) => {
        const blob = new Blob([data], {
          type: options.binary ? 'application/octet-stream' : 'text/plain',
        });
        resolve(blob);
      },
      {
        binary: options.binary ?? true,
        excludeAttributes: options.excludeAttributes ?? [],
      },
    );
  });
}

export function geometryToPly(geometry: BufferGeometry, options: PLYExportOptions = {}): Promise<Blob> {
  return new Promise((resolve) => {
    const tempMesh = new Mesh(geometry);

    const exporter = new PLYExporter();
    exporter.parse(
      tempMesh,
      (data: string | ArrayBuffer) => {
        const blob = new Blob([data], {
          type: options.binary ? 'application/octet-stream' : 'text/plain',
        });
        resolve(blob);
      },
      {
        binary: options.binary ?? true,
        excludeAttributes: options.excludeAttributes ?? [],
      },
    );
  });
}
